import { ITEM_COLORS, type ItemColor } from '@planer/shared';

export const COLOR_LABELS: Record<ItemColor, string> = {
  blue: 'Modra',
  green: 'Zelena',
  orange: 'Oranžna',
  red: 'Rdeča',
  purple: 'Vijolična',
  pink: 'Roza',
  teal: 'Turkizna',
  gray: 'Siva',
};

export const PALETTE = ITEM_COLORS;

/** CSS colour for an item (theme aware through CSS variables). */
export function itemColor(color: ItemColor | null | undefined): string {
  return color ? `var(--c-${color})` : 'var(--accent)';
}

/** Display colour of an occurrence: the calendar's colour for events, the item colour otherwise. */
export function occColor(occ: { color: ItemColor | null; calendar?: { color: string } }): string {
  return occ.calendar ? occ.calendar.color : itemColor(occ.color);
}
